$(document).ready(function(){